import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoClose, IoMenu, IoSettings } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import Logo from "../../../Images/logoIcon.png";
import { useAdminSession } from "../../../hooks/use-admin-session";
import { ADMIN_ROLES, clearSessionUser } from "../../../utils/adminSession";

const Navbar = ({ onMenuClick }) => {
  const { currentUser } = useAdminSession();
  const navigate = useNavigate();
  const profileRef = useRef(null);
  const [profileOpen, setProfileOpen] = useState(false);

  useEffect(() => {
    const closeProfile = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", closeProfile);
    return () => document.removeEventListener("mousedown", closeProfile);
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    clearSessionUser();
    navigate("/login");
  };

  return (
    <nav className="fixed inset-x-0 top-0 z-50 h-16 border-b border-gray-100 bg-white shadow-sm">
      <div className="flex h-full items-center justify-between px-3 sm:px-5 lg:px-6">
        <div className="flex min-w-0 items-center gap-2 sm:gap-3">
          <button
            type="button"
            onClick={onMenuClick}
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-purple lg:hidden"
            aria-label="Open navigation menu"
          >
            <IoMenu size={26} />
          </button>

           {/* Logo in the center */}
                     <div className="hidden sm:block text-2xl font-bold">
                       <a href="/" className="flex items-center gap-1">
                         <img
                           className="w-14 h-14 object-contain"
                           src={Logo}
                           alt="Adhyayi Logo"
                         />
         
                         <span className="text-bgBlue font-agrandir tracking-[2px] text-3xl">
                           Adhyayi
                         </span>
                       </a>
                     </div>
        </div>

        <div ref={profileRef} className="relative">
          <button
            type="button"
            onClick={() => setProfileOpen((open) => !open)}
            className="inline-flex h-10 items-center gap-2 rounded-lg bg-purple px-3 text-white hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-purple focus:ring-offset-2"
            aria-label="Open profile menu"
            aria-expanded={profileOpen}
          >
            <IoSettings size={20} />
            <span className="hidden max-w-32 truncate text-sm font-semibold sm:block">
              {currentUser?.fullName || currentUser?.name || "Admin"}
            </span>
          </button>

          {profileOpen && (
            <div className="absolute right-0 top-12 z-50 w-[calc(100vw-1.5rem)] max-w-72 rounded-xl border border-gray-100 bg-white p-4 text-left shadow-xl">
              <button
                type="button"
                onClick={() => setProfileOpen(false)}
                className="absolute right-2 top-2 rounded-full p-1 text-gray-500 hover:bg-gray-100"
                aria-label="Close profile menu"
              >
                <IoClose size={20} />
              </button>

              <div className="flex min-w-0 items-center gap-3 pr-6">
                {currentUser?.profilePicUrl ? (
                  <img
                    src={currentUser.profilePicUrl}
                    alt={currentUser?.fullName || currentUser?.name || "Admin"}
                    className="h-12 w-12 shrink-0 rounded-full border object-cover"
                  />
                ) : (
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-purple text-lg font-bold text-white">
                    {(currentUser?.fullName || currentUser?.name || "A")
                      .charAt(0)
                      .toUpperCase()}
                  </div>
                )}

                <div className="min-w-0">
                  <h2 className="truncate font-bold text-gray-800">
                    {currentUser?.fullName || currentUser?.name || "Admin"}
                  </h2>
                  <p className="truncate text-sm text-gray-500">
                    {currentUser?.email || "-"}
                  </p>
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between gap-3 border-t pt-3">
                <div className="min-w-0">
                  <p className="text-xs text-green-600">Access Role</p>
                  <h3 className="truncate font-semibold text-purple">
                    {currentUser?.role === ADMIN_ROLES.SUPER_ADMIN
                      ? "Super Admin"
                      : "Admin"}
                  </h3>
                </div>

                <button
                  type="button"
                  onClick={logout}
                  className="inline-flex shrink-0 items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold text-red-500 hover:bg-red-50"
                >
                  <LuLogOut size={18} />
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
